'use client';
import { createContext, PropsWithChildren, useContext } from 'react';
import getSectionContext, {
  SectionContext as SectionContextType,
  SectionContextProps,
} from './getSectionContext';

type ContextType = SectionContextType;
type Props = SectionContextProps;

const SectionContext = createContext<ContextType>({
  index: -1,
  isEven: true,
  attrData: {
    id: '',
    type: '',
  },
  config: {
    id: '',
    header: {
      cta: {},
    },
    updatedAt: '',
    createdAt: '',
  },
});

export const SectionContextProvider = ({
  children,
  index,
  section,
  config,
}: PropsWithChildren<Props>) => {
  return (
    <SectionContext.Provider
      value={{ ...getSectionContext({ index, section, config }) }}
    >
      {children}
    </SectionContext.Provider>
  );
};

export const useSectionContext = () => useContext(SectionContext);
